var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',[_c('CommercantHeader'),_c('CommercantContent',{on:{"loaded":function($event){_vm.scrollInitialized = true}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }